import React from 'react';
import { withUploadsToken } from '@/utils/uploadsAuth';
import { getListArtUrl } from '@/utils/albumArt';

/**
 * A cover for a LIST row: the small thumbnail, loaded lazily. Falls back to the original once if the thumbnail
 * is missing (uploads from before thumbnails existed), then hides itself. AUTO-083: the Critic tab and the
 * Compare picker used to load every song's full-size cover (about 3.9 MB each) into a 40px box.
 */
export function ArtThumb({ url, alt, className }: { url: string; alt: string; className?: string }) {
  const thumb = getListArtUrl(url);
  return (
    <img
      src={withUploadsToken(thumb)}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={className}
      onError={(e) => {
        const img = e.currentTarget;
        if (img.dataset.fallback !== 'true' && thumb !== url) {
          img.dataset.fallback = 'true';
          img.src = withUploadsToken(url);
        } else {
          img.style.display = 'none';
        }
      }}
    />
  );
}
